// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const PowerOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","focusable":"false"},"children":[{"tag":"g","attrs":{"clip-path":"url(#clip0_123_2642)"},"children":[{"tag":"path","attrs":{"d":"M13 3h-2v10h2V3zm4.83 2.17l-1.42 1.42a7 7 0 11-8.83-.01L6.17 5.17a9 9 0 1011.66 0z","fill":"currentColor"}}]},{"tag":"defs","attrs":{},"children":[{"tag":"clipPath","attrs":{"id":"clip0_123_2642"},"children":[{"tag":"path","attrs":{"d":"M0 0h24v24H0z","fill":"currentColor"}}]}]}]},"name":"power","theme":"outlined"};

const PowerOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={PowerOutlinedSvg} />;
  PowerOutlined.displayName = 'PowerOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(PowerOutlined);
